import React, {useEffect, useState} from 'react';

export interface AiHelpChatProps {
    apiKey: string;
    domain: string;
    appId: string;
}

const AiHelpChat: React.FC<AiHelpChatProps> = (props) => {
    const {apiKey, domain, appId} = props;

    const [isInit, setIsInit] = useState(false);

    useEffect(() => {
        // 检查脚本是否已经加载
        if (document.getElementById('aihelp-script')) {
            // 如果已经加载，直接初始化
            if (window.AIHelpSupport && !isInit) {
                window.AIHelpSupport.initialize({apiKey, domain, appId});
            }
            return;
        }

        // 创建脚本标签
        const script = document.createElement('script');
        script.id = 'aihelp-script';
        script.src = 'https://cdn.aihelp.net/webchatv5/aihelp.js';
        script.async = true;

        script.onload = () => {
            if (window.AIHelpSupport) {
                window.AIHelpSupport.initialize({apiKey, domain, appId});
            } else {
                console.error('AIHelp 脚本加载后未找到 AIHelp 对象');
            }
        };

        script.onerror = () => {
            console.error('AIHelp 脚本加载失败');
        };

        // 将脚本添加到文档头部
        document.head.appendChild(script);

        // 清理函数（可选）
        return () => {
            // 根据需要决定是否移除脚本或进行其他清理
            // document.head.removeChild(script);
        };
    }, [apiKey, domain, appId]);

    return null; // 这个组件不需要渲染任何内容
};

export default AiHelpChat;
